import { render, staticRenderFns } from "./bestsellerRankAsins.vue?vue&type=template&id=5e077794&scoped=true"
import script from "./bestsellerRankAsins.vue?vue&type=script&lang=js"
export * from "./bestsellerRankAsins.vue?vue&type=script&lang=js"
import style0 from "./bestsellerRankAsins.vue?vue&type=style&index=0&id=5e077794&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e077794",
  null
  
)

export default component.exports